import { styled } from '@clickcease/cc-client-components-lib'

export const ThreatTypesAndGroupsWidgetWrapper = styled('div', {
  marginTop: '20px',
  display: 'flex',
  gap: '20px',
  width: '100%',
})

export const ThreatTypesAndGroupsWidgetTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: '600',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 20px',
  position: 'relative',

  '& > button': {
    position: 'absolute',
    right: '45px',
  },
})

export const ThreatTypesAndGroupsWidgetTitleText = styled('div', {})

export const ThreatTypesAndGroupsWidgetCard = styled('div', {
  borderRadius: '14px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  background: '$white',
  flex: '1 1 0',
  '& > div': {
    width: '100% !important',
    maxWidth: '100% !important',
    overflowX: 'hidden !important',
  },
  '& > button': {
    position: 'absolute !important',
    right: '50px !important',
  },
})
